<template>
    <div id="shareInviteinfo" >
        <div class="share-tittle">分享链接或者二维码通知加入</div>
        <div class="share-tips">将链接或二维码分享给成员，成员通过打开链接或者识别二维码快速申请加入，待管理员审核通过后即可成功加入。</div>
        <div v-loading="loading" element-loading-text="二维码和链接加载中..." element-loading-background="rgba(255,255,255, 0.8)">   
            <div class="common-wraper" style="margin-top:20px">
                <div style="display:flex;align-items:center" class="link-box">
                    <div class="text-tip">链接 :</div>
                    <el-input v-model="qrCodeUrl" placeholder="" size="medium" style="width:370px;margin-left:40px"></el-input>
                </div>
                <el-button type="primary" size="medium" style="" @click="copyLinkClick($event)">复制邀请链接</el-button>
            </div>
            <div class="common-wraper" style="margin-top:40px">
                <div style="display:flex;align-items:center" class="link-box">
                    <div class="text-tip">二维码 :</div>
                    <div class="codebox" style="width:120px;height:120px;margin-left:25px" >
                        <img :src="codeimg" alt="" style="width:120px;">
                    </div>
                </div>
                <el-button type="primary" size="medium" style="width:126px" @click="download">下载二维码</el-button>
            </div>
            <div class="" style="margin-top:50px;margin-bottom:0px;display:flex;align-items:center">
                <div class="text-tip">链接和二维码有效期 ：</div>
                <el-select v-model="effectivityDays" placeholder="" size="medium" @change="selectchange">
                    <el-option
                        v-for="item in timeoptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        
        <!-- <div class="link-wraper">
            <span class="linkstyle">点击链接加入我的企业“{{enterpriseName}}”，一起开启全新的PKPM之旅。</span>
            <div class="linkstyle link">{{qrCodeUrl}}</div>
        </div>
        <el-button type="primary" size="medium" style="margin-top:20px" @click="copyLinkClick($event)">复制邀请链接</el-button>
        <div class="codebox" style="width:120px;height:120px;margin-top:40px" >
            <img :src="codeimg" alt="" style="width:120px;">
        </div>
        <el-button type="primary" size="medium" style="margin-top:20px" @click="download">下载二维码</el-button> -->

    </div>
</template>

<script>
    import  {BASE_URL} from "../../../../config/env";
    import clip from '@/utils/clipboard' // use clipboard directly
    import {CreateInviteUserLinkApi} from '@/js/enterPriseApi.js'
    export default {
        data(){
            return {
                qrCodeUrl:'',
                enterpriseName:'',
                codeimg:'',
                loading:false,
                effectivityDays:7,
                timeoptions:[
                    {
                        label:'7天',
                        value:7
                    },
                    {
                        label:'30天',
                        value:30
                    },
                    {
                        label:'90天',
                        value:90
                    }

                ]
            }
        },
        created(){
            this.createLink()
        },
        methods:{
            selectchange(){
                this.createLink()
            },
            createLink(){
                let that=this;
                
                this.loading=true
                console.log('创建链接')
                CreateInviteUserLinkApi({
                    enterpriseId:window.localStorage.getItem('enterPriseId'),
                    effectivityDays:this.effectivityDays
                })
                .then(res=>{
                    this.loading=false
                    if(res.status===200 && res.data.error_code===0){
                        const {data}=res.data
                        this.qrCodeUrl=''
                        this.codeimg=''
                        this.qrCodeUrl=data.qrCodeUrl
                        this.enterpriseName=data.enterpriseName
                        this.codeimg='data:image/png;base64,'+data.qrCodeData

                    }else{
                        this.$message.error(res.data.error_msg)
                    }
                })
                .catch(err=>{
                    this.loading=false
                    if(err.data && err.data.errorMessages){
                        that.$message.error(err.data.errorMessages[0]);
                    }else if(err.data){
                        that.$message.error(err.data);
                    }
                })
            },
            copyLinkClick (event) {
                if(this.qrCodeUrl){
                    clip(this.qrCodeUrl, event)
                }else{
                    return
                }
            },
            download() {
                var date = new Date();
                if (!this.codeimg) {
                    return;
                }
                var aLink = document.createElement("a"); // 创建一个a标签
                var blob = this.base64ToBlob(this.codeimg);
                var event = document.createEvent("HTMLEvents");
                event.initEvent("click", true, true);
                aLink.download = date.getTime() + "." + blob.type.split("/")[1]; // 使用时间戳给文件命名
                aLink.href = URL.createObjectURL(blob);
                aLink.click();
            },
             base64ToBlob(code) {
                var parts = code.split(";base64,");
                var contentType = parts[0].split(":")[1];
                var raw = window.atob(parts[1]);
                var rawLength = raw.length;
                var uint8Array = new Uint8Array(rawLength);
                for (var i = 0; i < rawLength; i++) {
                    uint8Array[i] = raw.charCodeAt(i);
                }
                return new Blob([uint8Array], {type: contentType});
            }
        }
    }
</script>

<style lang="scss" scoped>
    #shareInviteinfo{
        padding: 30px 40px;
        text-align: left;
        .share-tittle{
            font-family: MicrosoftYaHei;
            font-size: 16px;
            color: #333333;
            font-weight: 400;
        }
        .share-tips{
            margin-top: 20px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #666666;
            line-height: 22px;
        }
        .link-wraper{
            margin-top: 20px;
            padding: 9px 12px;
            background: #F7F7F7;
            border-radius: 1px solid #E0E0E0;
            .linkstyle{
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #666666;
                line-height: 18px;
                font-weight: 400;
            }
            .link{
                cursor: pointer;
            }
        }
        .common-wraper{
            display: flex;
            justify-content: space-between;
            align-items: center;
            
        }
        .text-tip{
                opacity: 0.66;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #666666;
                font-weight: 400;
            }
        .link-box{
            /deep/ .el-input .el-input__inner {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                
            }
        }
        /deep/ .el-loading-spinner .el-loading-text{
            font-size: 14px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/companyManage/shareInviteinfo.vue